// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BfAJt","clinicsSelect":"styles_clinicsSelect__Y103y"};